module.exports = {"id":"186581","name":"Keisuke Honda","rating":"79","photo":"./data/images/photos/1/186581.png","club":{"name":"Pachuca","logo":"./data/images/clubs/Pachuca.png"},"positions":["MD","MOC","AD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KeisukeHonda0.json
// module id = 2307
// module chunks = 0